'use strict';

angular.module('ClinicApp').directive('hours', function(OCHoursUtil) {
  return {
    scope: {
      hours: '=',
      editMode: '=',
      defaultHours: '=',
      type: '=',
    },
    transclude: true,
    templateUrl: '/views/directives/_hours.html',
    link: function($scope) {
      $scope.isDayValid = OCHoursUtil.isDayValid;

      if ($scope.defaultHours && OCHoursUtil.isEmptyHours($scope.hours)) {
        // Set Mon-Fri from 9am to 5pm.
        for (var i = 1; i < 6; i++) {
          $scope.hours[i].start = 9 * 60;
          $scope.hours[i].end = 17 * 60;
        }
      }

      $scope.times = OCHoursUtil.hoursDropdownOptions();
      $scope.times[0].label = 'Closed'; // Represent midnight as closed.
      $scope.timesByValue = _.indexBy($scope.times, 'value');

      $scope.checkHours = function(index, previousValue) {
        var previouslyClosed = previousValue > 0;
        var hours = $scope.hours[index];

        // Start time: closed, end time: open.
        if (!hours.start && hours.end) {
          if (previouslyClosed) {
            // Trasitioning from closed, set start to match end.
            hours.start = hours.end;
          } else {
            // Trasitioning to closed, set end to closed.
            hours.end = 0;
          }
        }

        // Start time: open, end time: closed.
        if (hours.start && !hours.end) {
          if (previouslyClosed) {
            // Trasitioning from closed, set end to match start.
            hours.end = hours.start;
          } else {
            // Trasitioning to closed, set start to closed.
            hours.start = 0;
          }
        }
      };

    },
  };
});
